import type { Identifier } from "react-admin";

export type HouseVisitStopStatus = "PENDING" | "VISITED" | "SKIPPED" | "NOT_HOME";

export type HouseVisitEventRecord = {
  id: Identifier;
  name: string;
  hijriYear: string;
  fromDate: string;
  toDate: string;
};

export type HouseVisitSlotRecord = {
  id: Identifier;
  eventId: string;
  date: string;
  label?: string | null;
  capacity: number;
  stopCount?: number;
  _count?: { stops?: number };
  stops?: Array<{
    id: string;
    hofItsNo: string;
    sortOrder: number;
    status: string;
  }>;
};

export type HouseVisitStopRecord = {
  id: Identifier;
  slotId: string;
  hofItsNo: string;
  sortOrder: number;
  status: HouseVisitStopStatus;
  remarks?: string | null;
  visitedAt?: string | null;
  hofName?: string | null;
  address?: string | null;
};

export type HouseVisitStopDetail = HouseVisitStopRecord & {
  slotDate?: string | null;
  hof: {
    ITS_ID: string;
    Full_Name: string | null;
    Address?: string | null;
    Building?: string | null;
    Street?: string | null;
    Area?: string | null;
    Housing?: string | null;
    Type_of_House?: string | null;
    Sector?: string | null;
    Sub_Sector?: string | null;
    City?: string | null;
    Pincode?: string | null;
    Mobile?: string | null;
  } | null;
  familyMembers: Array<{
    ITS_ID: string;
    Full_Name: string | null;
    Age?: string | null;
    Gender?: string | null;
    HOF_FM_TYPE?: string | null;
  }>;
  sabil: {
    lastPaidDate: string | null;
    sabilType?: string | null;
  } | null;
};

export const STOP_STATUS_LABELS: Record<HouseVisitStopStatus, string> = {
  PENDING: "Pending",
  VISITED: "Visited",
  SKIPPED: "Skipped",
  NOT_HOME: "Not home",
};

export const STOP_STATUS_COLORS: Record<
  HouseVisitStopStatus,
  "default" | "success" | "warning" | "error" | "info"
> = {
  PENDING: "default",
  VISITED: "success",
  SKIPPED: "warning",
  NOT_HOME: "error",
};
